<template>
    <v-dialog
    v-model="localDialog"
    width="35%"
    @update:modelValue="updateDialog"
    transition=""
    persistent
    :open-delay="0"
    :close-delay="0"
    >
        <v-card>
            <v-card-title class="text-h6">
                <span class="text-center">Project Update</span>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text>
                <v-form @submit.prevent="submit" ref="ProjectUpdateSetup">
                    <v-row>
                        <v-col cols="12">
                            <v-textarea
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="description.value.value"
                                :error-messages="description.errorMessage.value"
                                clearable
                            >
                                <template #label>
                                Description <span class="text-red-accent-4">*</span>
                                </template>
                            </v-textarea>

                            <v-date-input
                                input-format="dd/mm/yyyy"
                                prepend-icon=""
                                prepend-inner-icon="mdi-calendar"
                                label="Date"
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="date.value.value"
                                :error-messages="date.errorMessage.value"
                                autocomplete="off"
                                clearable
                            >
                                <template #label>
                                Date
                                <span class="text-red-accent-4">*</span>
                                </template>
                            </v-date-input>

                            <!-- <v-autocomplete
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="activity_id.value.value"
                                :items="getProjectActivityList"
                                :item-title="(item) => `${item.name}`"
                                item-value="id"
                                :error-messages="activity_id.errorMessage.value"
                                autocomplete="off"
                                clearable
                            
                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                <template #label>
                                Activity
                                <span class="text-red-accent-4">*</span>
                                </template>
                            </v-autocomplete> -->

                            <!-- <v-autocomplete
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="sub_activity_id.value.value"
                                :items="getProjectSubActivityList.filter(item => item.activity_id == activity_id.value.value)"
                                :item-title="(item) => `${item.name}`"
                                item-value="id"
                                :error-messages="sub_activity_id.errorMessage.value"
                                autocomplete="off"
                                clearable
                            
                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                <template #label>
                                    Type of Activity
                                    <span class="text-red-accent-4">*</span>
                                </template>
                            </v-autocomplete> -->

                            <!-- <v-checkbox
                                label="Active"
                                v-model="status.value.value"
                                :error-messages="status.errorMessage.value"
                                density="compact"
                                variant="outlined"
                                hide-details
                                single-line
                                color="primary"
                                value="1"
                            ></v-checkbox> -->
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-layout class="justify-end">
                            <v-btn
                                class="bg-red"
                                variant="flat"
                                type="reset"
                                @click="closeDialog"
                                >Close</v-btn
                            >
                            <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
                                {{ isEntryMode ? "Save" : "Update" }}
                            </v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import { useRoute } from "vue-router";
import formattedDate from '@/plugins/dateFormatter';

export default {
    name: "ProjectUpdateSetup",
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Object,
            default: () => ({
                status: "1",
            }),
        },
    },
    data() {
        return {
            localDialog: this.dialog,
            selectedImage: null,
            errorMessages: "",
            loading: false,
            isEntryMode: true,
        };
    },
    watch: {
        dialog(val) {
            this.localDialog = val;
        },
        localDialog(val) {
            this.$emit("update:dialog", val);
        },
        data: {
            handler(newData) {
                this.isEntryMode = !newData.project_id;
                this.resetForm({ errors: {}, touched: {} });
                this.status.setValue(String(newData.status) || "1", false);

                this.project_id.setValue(newData.project_id || "", false);
                // this.activity_id.setValue(newData.activity_id || "", false);
                // this.sub_activity_id.setValue(newData.sub_activity_id || "", false);
                this.date.setValue(
                    newData.date || "",
                    false
                );
                this.description.setValue(newData.description || "", false);
            },
        },
    },
    created() {
        // if (this.$store.getters.getProjectActivityList.length === 0) {
        //     this.$store.dispatch("getProjectActivityList");
        // }
     
        // if (this.$store.getters.getProjectSubActivityList.length === 0) {
        //     this.$store.dispatch("getProjectSubActivityList");
        // }
    },
    computed: {
        // getProjectActivityList() {
        //     return this.$store.getters.getProjectActivityList;
        // },
       
        // getProjectSubActivityList() {
        //     return this.$store.getters.getProjectSubActivityList;
        // },
    },
    methods: {
        updateDialog(val) {
            this.$emit("update:dialog", val);
        },
        closeDialog() {
            this.$emit("update:dialog", false);
        },
    },
    setup(props, { emit }) {
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                // sub_activity_id: yup.string().required().label("Sub Activity ID"),
                // activity_id: yup.string().required().label("Activity ID"),
                date: yup.string().required().label("Date"),
                description: yup.string().required().label("Description"),
                status: yup.string().required().label("Status"),
            }),
        });
        const project_id = useField("project_id");
        const description = useField("description");
        // const sub_activity_id = useField("sub_activity_id");
        // const activity_id = useField("activity_id");
        const date = useField("date");
        const status = useField("status", undefined, { initialValue: "1" });
        const errorMessages = ref("");
        const loading = ref("");
        const store = useStore();
        const route = useRoute();

        const submit = handleSubmit((values) => {
            values.date = formattedDate(
                date.value.value
            );
            // const formData = new FormData();
            // Object.keys(values).forEach((key) => { formData.append(key, values[key] || "");});
            const id = route.params.id;
            store.dispatch("saveUpdateProjectDetail", {
                id: id,
                data: values
                })
                .then((response) => {
                    resetForm();
                    emit("update:dialog", false);
                    toast.success(response.data.message);
                    loading.value = true;
                    store
                        .dispatch("getProjectActivityLogById", id)
                        .then((data) => {
                        loading.value = false;
                        })
                        .catch((error) => {
                        loading.value = false;
                        toast.error(error.response.data.message);
                        });
                })
                .catch((error) => {
                    toast.error(error.response.data.message);
                });
        });
        return {
            submit,
            project_id,
            // activity_id,
            // sub_activity_id,
            date,
            description,
            errorMessages,
            resetForm,
            status,
            loading,
        };
    },
    mounted() {

    },
};
</script>
